import { api } from '@src/constants/api';
import { createMiddleware, Next, regularErrorHandling } from '@src/utils';
import { scriptsActions } from '@src/store/reducers/scriptsReducer';

export const createScriptsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [scriptsActions.GET_SCRIPT_DATA]: async (action: any, next: Next) => {
            try {
                //projectId and packageId and scriptId is correct
                const url = `${restServiceUrl}Projects/${action.payload.projectId}/Packages/${action.payload.packageId}/Scripts/${action.payload.scriptId}/Data`;
                const response = await http({ method : 'GET', url });
                next({ type : scriptsActions.RECIEVED_SCRIPT_DATA, payload: { scriptData : response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [scriptsActions.GET_SCRIPT_DATA_WITHOUT_PACKAGE]: async (action: any, next: Next) => {
            try {
                //projectId is correct
                const url = `${restServiceUrl}Projects/${action.payload.projectId}/UnassignedScripts/${action.payload.scriptId}/Data`;
                const response = await http({ method : 'GET', url });
                next({ type: scriptsActions.RECIEVED_SCRIPT_DATA_WITHOUT_PACKAGE, payload: { scriptData : response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/scripts.middleware.ts